import React, { Fragment } from 'react';
import { concat, filter, includes } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';

import CheckBox from '../../../../../components/input/CheckBox';
import SearchBox from '../../../../../components/outline/SearchBox';
import BaseForm from '../../../../../components/form/BaseForm';
import ButtonList from '../../../../../components/ButtonList';
import DateRangePicker from '../../../../../components/datePicker/DateRangePicker';
import { LIST_PAGINATION_MODEL } from '../../../../../store/modules/app/models';
import {
  DATE_FORMAT,
  QUICK_DATE_SELECT_BUTTON_TARGET,
  SEARCH_PERIOD_BUTTON_ALL_TYPE,
} from '../../../../../constants/service/common/utilConstants';
import {
  ORDER_SEARCH_PERIOD_BUTTON_LIST,
  SEARCH_ORDER_STATUS_CHECK_BOX_LIST,
} from '../../../../../constants/service/app/orderConstants';
import { setQuickToDate } from '../../../../../lib/common';
import {
  ORDER_ALL_LIST_SEARCH_DATA_MODEL,
  ORDER_ALL_LIST_SEARCH_OPTION_MODEL,
} from '../../../../../store/modules/order/models';
import { orderActions } from '../../../../../store/modules/order';
import './OrderAllListSearchBox.scss';

const OrderAllListSearchBox = (props) => {
  const dispatch = useDispatch();
  const { getList } = props;

  const { searchData } = useSelector((state) => state.order.orderAllList);
  const { orderDate, orderItemStatusList } = searchData;

  const setData = (data) => dispatch(orderActions.setData(data));
  const setOrderAllListSearchData = (data) =>
    setData({
      path: ['orderAllList', 'searchData', ...data.path],
      value: data.value,
    });

  const searchOrderAllList = () => {
    /**
     * 날짜 선택 빠른 키 값이 전체가 아닌 경우에만 기간을 서버로 전송한다.
     * 날짜 선택이 전체인 경우 => quickDateIndex = -1
     */
    getList({
      searchOption: {
        /**
         *  주문 일시
         */
        orderDate: orderDate.quickDateIndex !== SEARCH_PERIOD_BUTTON_ALL_TYPE ? orderDate.period : null,
        /**
         *  주문 상태 리스트
         */
        orderItemStatusList,
      },
      pagination: LIST_PAGINATION_MODEL,
    });
  };

  const getInitialOrderList = () => {
    getList({
      searchOption: ORDER_ALL_LIST_SEARCH_OPTION_MODEL,
      pagination: LIST_PAGINATION_MODEL,
    });
    setOrderAllListSearchData({
      path: [],
      value: ORDER_ALL_LIST_SEARCH_DATA_MODEL,
    });
  };

  return (
    <SearchBox className="order-all-list-search-box" onSearch={searchOrderAllList} onClear={getInitialOrderList}>
      {/*주문 일시*/}
      <BaseForm
        label="주문 일시"
        content={
          <div className="quick-date-picker">
            {/*날짜 선택 빠른 키*/}
            <ButtonList
              current={orderDate.quickDateIndex}
              list={ORDER_SEARCH_PERIOD_BUTTON_LIST}
              onClick={(data) =>
                setOrderAllListSearchData({
                  path: ['orderDate'],
                  value: setQuickToDate({
                    id: data.id,
                    value: data.value,
                    target: QUICK_DATE_SELECT_BUTTON_TARGET.START_DATE,
                    period: orderDate.period,
                  }),
                })
              }
            />

            {/*날짜 선택*/}
            <DateRangePicker
              value={orderDate.period}
              outFormat={DATE_FORMAT.YMD_DASH_FORMAT}
              onSelect={(period) =>
                setOrderAllListSearchData({
                  path: ['orderDate'],
                  value: setQuickToDate({
                    period,
                  }),
                })
              }
            />
          </div>
        }
      />

      {/*주문 상태*/}
      <BaseForm
        label="주문 상태"
        content={
          <Fragment>
            {SEARCH_ORDER_STATUS_CHECK_BOX_LIST.map((item) => (
              <CheckBox
                key={item.id}
                checked={includes(orderItemStatusList, item.id)}
                text={item.name}
                onChange={(checked) =>
                  setOrderAllListSearchData({
                    path: ['orderItemStatusList'],
                    value: checked
                      ? concat(orderItemStatusList, item.id)
                      : filter(orderItemStatusList, (id) => id !== item.id),
                  })
                }
              />
            ))}
          </Fragment>
        }
      />
    </SearchBox>
  );
};

export default OrderAllListSearchBox;
